'use client';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { usePathname } from 'next/navigation';
import FeaturesRow_Layout1 from './FeaturesRowLayout/Layout1';
interface Feature {
  title: string;
  description: string;
  media: {
    data: {
      attributes: {
        url: string;
        alternativeText: string;
      };
    };
  };
}

interface FeaturesRowProps {
  data: {
    title: string;
    description: string;
    features: Feature[];
    isLive: boolean;

  };
}

export default function FeaturesRow({ data }: FeaturesRowProps) {
  const pathName = usePathname();

  if (!data.isLive)
    return <></>;

  return (
    <>
      {
        <FeaturesRow_Layout1 data={data} />
      }
    </>
  );
}